<div class="modal-header">
  <h5 class="modal-title">Category Details</h5>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="mediaTypeForm" (ngSubmit)="onSubmit()" class="form-group row">
    <!-- Left Column -->
    <div class="col-md-6">
      <!-- Image URL -->
     <!--  <div class="form-group">
        <label for="imageUrl">Image URL
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the URL of the image"></i>
        </label>
        <input formControlName="imageUrl" type="text" id="imageUrl" class="form-control"
               placeholder="http://example.com/image.jpg">
      </div> -->

      <!-- Name -->
      <div class="form-group">
        <label for="name">Name
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the name of the media type"></i>
        </label>
        <input formControlName="name" type="text" id="name" class="form-control"
               placeholder="Book, DVD, etc.">
      </div>

      <!-- Code -->
      <div class="form-group">
        <label for="code">Code
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter a unique code"></i>
        </label>
        <input formControlName="code" type="text" id="code" class="form-control"
               placeholder="BK123">
      </div>

      <!-- Parent Code -->
      <div class="form-group">
        <label for="parentCode">Parent Code
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the parent code"></i>
        </label>
        <input formControlName="parentCode" type="text" id="parentCode" class="form-control"
               placeholder="Enter parent code (optional)">
      </div>

      <!-- Search Category -->
    <!--   <div class="form-group">
        <label for="searchCategory">Search Category
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the search category"></i>
        </label>
        <input formControlName="searchCategory" type="text" id="searchCategory" class="form-control"
               placeholder="Fiction, Non-Fiction, etc.">
      </div> -->
    </div>

    <!-- Right Column -->
    <div class="col-md-6">
      <!-- Not for Loan -->
      <div class="form-group">
        <label for="notForLoan">Not for Loan
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Check if not available for loan"></i>
        </label>
        <input formControlName="notForLoan" type="checkbox" id="notForLoan">
      </div>

      <!-- Rental Charge -->
      <div class="form-group">
        <label for="rentalCharge">Rental Charge
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter rental charge"></i>
        </label>
        <div class="input-group">
          <input formControlName="rentalCharge" type="number" step="0.01" id="rentalCharge" class="form-control"
                 placeholder="5.00">
          <div class="input-group-append">
            <span class="input-group-text">USD</span>
          </div>
        </div>
      </div>

      <!-- Daily Rental Charge -->
      <div class="form-group">
        <label for="dailyRentalCharge">Daily Rental Charge
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter daily rental charge"></i>
        </label>
        <div class="input-group">
          <input formControlName="dailyRentalCharge" type="number" step="0.01" id="dailyRentalCharge" class="form-control"
                 placeholder="1.00">
          <div class="input-group-append">
            <span class="input-group-text">USD/day</span>
          </div>
        </div>
      </div>

      <!-- Hourly Rental Charge -->
      <div class="form-group">
        <label for="hourlyRentalCharge">Hourly Rental Charge
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter hourly rental charge"></i>
        </label>
        <div class="input-group">
          <input formControlName="hourlyRentalCharge" type="number" step="0.01" id="hourlyRentalCharge" class="form-control"
                 placeholder="0.50">
          <div class="input-group-append">
            <span class="input-group-text">USD/hour</span>
          </div>
        </div>
      </div>

      <!-- Default Replacement Cost -->
      <div class="form-group">
        <label for="defaultReplacementCost">Default Replacement Cost
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter replacement cost"></i>
        </label>
        <div class="input-group">
          <input formControlName="defaultReplacementCost" type="number" step="0.01" id="defaultReplacementCost" class="form-control"
                 placeholder="25.00">
          <div class="input-group-append">
            <span class="input-group-text">USD</span>
          </div>
        </div>
      </div>

      <!-- Processing Fee -->
      <div class="form-group">
        <label for="processingFee">Processing Fee (when lost)
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter processing fee"></i>
        </label>
        <div class="input-group">
          <input formControlName="processingFee" type="number" step="0.01" id="processingFee" class="form-control"
                 placeholder="10.00">
          <div class="input-group-append">
            <span class="input-group-text">USD</span>
          </div>
        </div>
      </div>

      <!-- Checkin Message -->
      <div class="form-group">
        <label for="checkinMessage">Checkin Message
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter check-in message"></i>
        </label>
        <input formControlName="checkinMessage" type="text" id="checkinMessage" class="form-control"
               placeholder="Message upon check-in">
      </div>

      <!-- Library Limitations -->
      <div class="form-group">
        <label for="libraryLimitations">Library Limitations
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter library limitations"></i>
        </label>
        <input formControlName="libraryLimitations" type="text" id="libraryLimitations" class="form-control"
               placeholder="Enter any limitations">
      </div>
    </div>

    <!-- Submit Button -->
    <div class="form-group col-md-12">
      <button type="submit" class="btn btn-outline-primary">
        <i class="fas fa-save"></i> Save
      </button>
     <!--  <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
        <i class="fas fa-times"></i> Cancel
      </button> -->
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="button-group">
    <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">
      <i class="fas fa-times"></i> Close
    </button>
  </div>
</div>
